import { ProcedimentoData } from "../../../../interfaces/entities/ProcedimentoData";
import { faCircleInfo } from "@fortawesome/pro-duotone-svg-icons";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import LightTooltip from "../../../../components/LightTooltip";

const ProcedimentoDetalhes: React.FC<{ data: ProcedimentoData; }> = ({ data }) => {

  const accessibility = useAccessibility();

  return (
    <div className="procedimento-data-card" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
      <div style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
        <span className="procedimento-data-key" style={accessibility.textStyleAccessibility}>Código TUSS</span>
        <span className="procedimento-data-value" style={accessibility.textStyleAccessibility}>{data.codigo}</span>
      </div>
      <div>
        <span className="procedimento-data-key" style={accessibility.textStyleAccessibility}>Procedimento</span>
        <span className="procedimento-data-value" style={accessibility.textStyleAccessibility}>{data.procedimento}</span>
      </div>
      {
        data.valor &&
        <div style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
          <div className="procedimento-data-key center-items" style={accessibility.textStyleAccessibility}>
            <span>
              Valor máximo de reembolso 
            </span>
            {
              data.tooltipText && 
              <LightTooltip title={data.tooltipText}>
                <FontAwesomeIcon icon={faCircleInfo} className="info-icon"/>
              </LightTooltip>
            }
          </div>
          <span className="procedimento-data-value" style={accessibility.textStyleAccessibility}>{data.valor}</span>
        </div>
      }
      
    </div>
  )
}

export default ProcedimentoDetalhes;